import { Article } from '../types';
import { getAllArticles } from './articles';

export const searchArticles = (searchTerm: string): Article[] => {
  const articles = getAllArticles();
  const term = searchTerm.toLowerCase();
  
  return articles
    .filter(article => {
      const titleMatch = article.title.toLowerCase().includes(term);
      const descriptionMatch = article.description.toLowerCase().includes(term);
      const contentMatch = article.content.toLowerCase().includes(term);
      const tagsMatch = article.tags.some(tag => tag.toLowerCase().includes(term));
      const categoryMatch = article.category.toLowerCase().includes(term);
      
      return titleMatch || descriptionMatch || contentMatch || tagsMatch || categoryMatch;
    })
    .sort((a, b) => {
      // Prioritize title matches
      const aTitle = a.title.toLowerCase().includes(term) ? 1 : 0;
      const bTitle = b.title.toLowerCase().includes(term) ? 1 : 0;
      
      if (aTitle !== bTitle) return bTitle - aTitle;
      
      // Then category matches
      const aCategory = a.category.toLowerCase().includes(term) ? 1 : 0;
      const bCategory = b.category.toLowerCase().includes(term) ? 1 : 0;
      
      if (aCategory !== bCategory) return bCategory - aCategory;
      
      // Finally, by last updated
      return new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime();
    })
    .slice(0, 10); // Return top 10 results
};